var React = require('react');

function OpenQuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Open Quote","d":"M490.214,345.608q0-13.924.232-27.146t.7-24.366q1.392-39.912,12.763-60.108T547.3,213.8l5.569,23.665q-18.1.473-23.206,12.072t-5.105,29.7h32.488v66.369Zm95.143,0q0-13.924.232-27.146t.7-24.366q1.393-39.912,12.763-60.108T642.443,213.8l5.569,23.665q-18.1.473-23.206,12.072t-5.105,29.7H652.19v66.369Z","transform":"translate(-486.214 -209.803)","fill":"none","stroke":"#f6a352","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"8","opacity":"0.3"}));
}

OpenQuoteInline.defaultProps = {"width":"169.976","height":"139.805","viewBox":"0 0 169.976 139.805"};

module.exports = OpenQuoteInline;

OpenQuoteInline.default = OpenQuoteInline;
